export const extractTemplateVariables = (templateData) => {
  if (!templateData) return [];
  const regex = /{{(\d+)}}/g;
  const matches = templateData.matchAll(regex);
  return Array.from(matches, (match) => match[0]);
};
